import { useEffect } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';

export interface SettingItem {
  title: string;
  description: string;
  onClick: () => void;
  key?: string;
}

interface SettingsListProps {
  settings: SettingItem[];
  selectedSetting: string | null;
}

export const SettingsList = ({
  settings,
  selectedSetting,
}: SettingsListProps) => {
  const theme = useTheme();

  useEffect(() => {
    if (!selectedSetting && settings.length > 0) {
      settings[0].onClick();
    }
  }, [selectedSetting, settings]);

  return (
    <List sx={{ width: '100%', p: 0, m: 0 }} component="nav">
      {settings.map((setting, index) => {
        const settingKey =
          setting.key || setting.title.toLowerCase().replace(/\s+/g, '-');
        const isSelected =
          selectedSetting === settingKey || (!selectedSetting && index === 0);

        return (
          <Box key={setting.title}>
            <ListItem
              onClick={setting.onClick}
              sx={{
                cursor: 'pointer',
                backgroundColor: isSelected
                  ? theme.palette.action.selected
                  : 'transparent',
                '&:hover': {
                  backgroundColor: isSelected
                    ? theme.palette.action.selected
                    : theme.palette.action.hover,
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body2" fontWeight="bold">
                    {setting.title}
                  </Typography>
                }
                secondary={setting.description}
              />
              <ListItemIcon sx={{ minWidth: 'auto' }}>
                <ChevronRightIcon />
              </ListItemIcon>
            </ListItem>
            {index < settings.length - 1 && <Divider />}
          </Box>
        );
      })}
    </List>
  );
};
